import { useEffect, useState } from 'react';

export default function AddProductModal({ categories, onClose, onAdd }) {
  const [formData, setFormData] = useState({
  name: '',
  brand: '',
  price: '',
  discount: '',
  originalPrice: '',
  description: '',
  badge: '',
  category: '',
  images: []
});

  const [errors, setErrors] = useState({});
  const [previewUrls, setPreviewUrls] = useState([]);

  const handleSubmit = async (e) => {
  e.preventDefault();

  const newErrors = {};
  if (!formData.name.trim())
    newErrors.name = 'Product name is required';

  if (!formData.price || parseFloat(formData.price) <= 0)
    newErrors.price = 'Valid price is required';

  if (!formData.category)
  newErrors.category = "Category is required";

  if (!formData.images.length)
    newErrors.images = 'At least one image is required';

  if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors);
    return;
  }

  const payload = new FormData();

  payload.append("name", formData.name.trim());
  payload.append("brand", formData.brand);
  payload.append("price", formData.price);
  payload.append("discount", formData.discount);
  payload.append("originalPrice", formData.originalPrice);
  payload.append("description", formData.description);
  payload.append("badge", formData.badge);
  payload.append("category", formData.category);

  formData.images.forEach((file) => {
    payload.append("images", file);
  });

  await onAdd(payload);
};

useEffect(() =>{
  return () => {
    previewUrls.forEach((url) => URL.revokeObjectURL(url))
  };
}, [previewUrls])


  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
          <h2 className="text-xl font-bold text-gray-900">Add New Product</h2>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer"
          >
            <i className="ri-close-line text-2xl"></i>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6">
          <div className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">
                Product Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                className={`w-full px-4 py-2.5 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#EF579A] ${
                  errors.name ? 'border-red-500' : 'border-gray-300'
                }`}
                placeholder="Enter product name"
              />
              {errors.name && <p className="mt-1 text-xs text-red-500">{errors.name}</p>}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">
                  Price <span className="text-red-500">*</span>
                </label>
                <input
                  type="number"
                  step="0.01"
                  value={formData.price}
                  onChange={(e) => setFormData({ ...formData, price: e.target.value })}
                  className={`w-full px-4 py-2.5 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#EF579A] ${
                    errors.price ? 'border-red-500' : 'border-gray-300'
                  }`}
                  placeholder="0.00"
                />
                {errors.price && <p className="mt-1 text-xs text-red-500">{errors.price}</p>}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">
                  Original Price
                </label>
                <input
                  type="number"
                  step="0.01"
                  value={formData.originalPrice}
                  onChange={(e) => setFormData({ ...formData, originalPrice: e.target.value })}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#EF579A]"
                  placeholder="0.00"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">Discount</label>
                <input
                  type="text"
                  value={formData.discount}
                  onChange={(e) => setFormData({ ...formData, discount: e.target.value })}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#EF579A]"
                  placeholder="e.g., -20%"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">Badge</label>
                <select
                  value={formData.badge}
                  onChange={(e) => setFormData({ ...formData, badge: e.target.value })}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#EF579A] cursor-pointer"
                >
                  <option value="">No Badge</option>
                  <option value="New">New</option>
                  <option value="Sale">Sale</option>
                  <option value="Hot">Hot</option>
                </select>
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">
                Category <span className="text-red-500">*</span>
              </label>
              <select value={formData.category}
              onChange={(e) =>
                setFormData({ ...formData, category: e.target.value })
              }
              className={`w-full px-4 py-2.5 border rounded-lg text-sm ${
                errors.category ? "border-red-500" : "border-gray-300"
              }`}>
                <option value="">Select category</option>
                {categories.map((cat) => (
                  <option key={cat._id} value={cat._id}>
                    {cat.name}
                    </option>
                ))}
              </select>
              {errors.category && (
                <p className="mt-1 text-xs text-red-500">{errors.category}</p>
              )}
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Description
              </label>
              <textarea
              value={formData.description}
              onChange={(e) =>
              setFormData({ ...formData, description: e.target.value })}
              rows={3}
              className="w-full px-4 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#EF579A]"/>
              </div>


            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">
                Product Images <span className="text-red-500">*</span>
              </label>
              <input
              type="file" multiple
              accept="image/*"
              onChange={(e) => {
                const files = Array.from(e.target.files);
                setFormData({ ...formData, images: files });

                // Generate preview URLs
                const previews = files.map((file) => URL.createObjectURL(file));
                setPreviewUrls(previews);
              }}
                className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm"
                />
              {errors.images && (
                <p className="mt-1 text-xs text-red-500">{errors.images}</p>
                )}
            </div>


            {previewUrls.length > 0 && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">
                  Image preview
                </label>

                <div className="flex gap-3 flex-wrap">
                  {previewUrls.map((url, index) => (
                    <div
                    key={index}
                    className="w-24 h-24 bg-gray-100 rounded-lg overflow-hidden border border-gray-200"
                    >
                      <img src={url} alt="Preview"
                      className="w-full h-full object-cover"
                       />
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          <div className="flex items-center justify-end gap-3 mt-6 pt-6 border-t border-gray-200">
            <button
              type="button"
              onClick={onClose}
              className="px-5 py-2.5 border border-gray-300 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-5 py-2.5 bg-[#EF579A] text-white rounded-lg text-sm font-medium hover:bg-[#D94A85] transition-colors whitespace-nowrap cursor-pointer"
            >
              Add Product
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
